<template>
  <a-modal v-model="modal" title="批量修改" width="500px" :maskClosable="false" :closable="false">
    <a-form-model :model="formData" ref="form">
      <!-- 订单满足率编辑 -->
      <template v-if="tabType === '订单满足率'">
        <a-form-model-item
          label="订单满足率"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="satisfyRate"
        >
          <a-input-number
            v-model="formData.satisfyRate"
            :min="0"
            :max="100"
            placeholder="请输入订单满足率"
            style="width: 100%"
          />
          <div class="field-hint">留空则不修改此字段</div>
        </a-form-model-item>
        <a-form-model-item
          label="欠货天数"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="oweGoodsDay"
        >
          <a-input-number
            v-model="formData.oweGoodsDay"
            :min="0"
            :parser="(value) => `${value}`.replace(/\D/g, '')"
            :formatter="(value) => `${value}`.replace(/\D/g, '')"
            placeholder="请输入欠货天数"
            style="width: 100%" />
          <div class="field-hint">留空则不修改此字段</div>
        </a-form-model-item>
        <a-form-model-item
          label="计算方式"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="calculationType"
        >
          <a-select v-model="formData.calculationType" placeholder="请选择计算方式" allowClear style="width: 100%">
            <a-select-option v-for="(item) in calculationTypeList" :key="item.code" :value="item.code" :label="item.name">
              {{ item.name }}
            </a-select-option>
          </a-select>
          <div class="field-hint">留空则不修改此字段</div>
        </a-form-model-item>
      </template>

      <!-- 快递类产品维护编辑 -->
      <template v-if="tabType === '快递类产品维护'">
        <a-form-model-item
          label="订单满足率"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="satisfyRate"
        >
          <a-input-number
            v-model="formData.satisfyRate"
            :min="0"
            :max="100"
            placeholder="请输入订单满足率"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item
          label="有效标识"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="flag"
        >
          <a-select v-model="formData.flag" placeholder="请选择有效标识" style="width: 100%">
            <a-select-option value="Y">有效</a-select-option>
            <a-select-option value="N">无效</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="欠货天数"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="oweGoodsDay"
        >
          <a-input-number
            v-model="formData.oweGoodsDay"
            :min="0"
            :parser="(value) => `${value}`.replace(/\D/g, '')"
            :formatter="(value) => `${value}`.replace(/\D/g, '')"
            placeholder="请输入欠货天数"
            style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item
          label="计算方式"
          :labelCol="{ style: 'width: 120px;float:left' }"
          :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
          prop="calculationType"
        >
          <a-select v-model="formData.calculationType" placeholder="请选择计算方式" style="width: 100%">
            <a-select-option v-for="(item) in calculationTypeList" :key="item.code" :value="item.code" :label="item.name">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </template>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment';
import { apiInvDeliveryProductsBatchEdit, apiInvOrderSatisfyRateBatchEdit } from '@/api/mes/scheduling-plan/order-satisfaction-rate'
import { CALCULATION_TYPE_LIST } from '../enum'

export default {
  name: 'BatchEditModal',
  data() {
    return {
      modal: false,
      title: '批量修改',
      formData: { satisfyRate: null, oweGoodsDay: null, calculationType: null, flag: null },
      loading: false,
      calculationTypeList: CALCULATION_TYPE_LIST,
      rules: {
        inputRequired: [{ required: true, message: ' ', trigger: 'blur' }],
        selectRequired: [{ required: true, message: ' ', trigger: 'change' }]
      },
      tabType: '', // tab标标识
      selectRow: []
    }
  },
  methods: {
    moment,
    show (selectRow, tabType) {
      this.tabType = tabType
      this.selectRow = selectRow || []
      this.$set(this.formData, 'satisfyRate', null)
      this.$set(this.formData, 'oweGoodsDay', null)
      this.$set(this.formData, 'calculationType', null)
      this.$set(this.formData, 'flag', null)
      this.modal = true
    },
    // 提交
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          // 订单满足率批量编辑 - 只传递非空字段
          if(this.tabType === '订单满足率') {
            const params = {
              ids: this.selectRow.map(v => v.id)
            }

            // 只传递有值的字段
            if(this.formData.satisfyRate !== null && this.formData.satisfyRate !== undefined && this.formData.satisfyRate !== '') {
              params.satisfyRate = this.formData.satisfyRate
            }
            if(this.formData.oweGoodsDay !== null && this.formData.oweGoodsDay !== undefined && this.formData.oweGoodsDay !== '') {
              params.oweGoodsDay = this.formData.oweGoodsDay
            }
            if(this.formData.calculationType !== null && this.formData.calculationType !== undefined && this.formData.calculationType !== '') {
              params.calculationType = this.formData.calculationType
            }

            // 检查是否有要修改的字段
            const hasChanges = Object.keys(params).length > 1 // 除了ids字段
            if(!hasChanges) {
              return this.$message.warning('请至少填写一个要修改的字段')
            }

            this.loading = true;
            apiInvOrderSatisfyRateBatchEdit(params).then(response => {
              if (response?.code === 200) {
                this.$message.success('修改完成')
                this.modal = false
                this.$emit("finallyUpdate")
              } else {
                this.$message.error(response.msg)
              }
            }).finally(() => {
              this.loading = false
            })
          } else if (this.tabType === '快递类产品维护') { // 快递类产品维护批量编辑 - 传递所有必填字段
            const params = {
              ids: this.selectRow.map(v => v.id),
              satisfyRate: this.formData.satisfyRate,
              oweGoodsDay: this.formData.oweGoodsDay,
              calculationType: this.formData.calculationType,
              flag: this.formData.flag
            }

            this.loading = true;
            apiInvDeliveryProductsBatchEdit(params).then(response => {
              if (response?.code === 200) {
                this.$message.success('修改完成')
                this.modal = false
                this.$emit("finallyUpdate")
              } else {
                this.$message.error(response.msg)
              }
            }).finally(() => {
              this.loading = false
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.field-hint {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
  line-height: 1.2;
}

/deep/ .ant-input-number {
  width: 100%;
}

/deep/ .ant-select {
  width: 100%;
}
</style>
